// extracted by mini-css-extract-plugin
export default {"feed":"FeedPhotos_feed__avuO-"};